var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","pa-3":""}},[_c('v-row',{staticClass:"center"},[_vm._v("\n\n    About Screen\n\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }